module.exports = __webpack_public_path__ + "img/grid-img-16.jpg";